import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-181">
      <FadeIn data-id="element-182">
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-183">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent" data-id="element-184"></div>

          <ShieldCheck className="w-16 h-16 text-amber-500 mx-auto mb-8" data-id="element-185" />

          <p className="text-xl md:text-2xl lg:text-3xl text-white font-medium leading-relaxed mb-8" data-id="element-186">
            En los próximos 7 días, dejarás de ver tus listas de tareas como
            amenazas. Lo que antes te tomaba 4 horas de "preparación mental"
            pasará a tomarte{' '}
            <span className="text-amber-400 font-bold" data-id="element-187">
              30 segundos de acción física.
            </span>
          </p>

          <p className="text-lg md:text-xl text-slate-300" data-id="element-188">
            No serás una persona diferente, pero tendrás un sistema que
            finalmente respeta cómo funciona tu cabeza.
          </p>
        </div>
      </FadeIn>
    </section>;
}